<template>
  <div>
    <page-content-toolbar
      :title="$t('global.sourceViewer')"
    />

    <v-card
      elevation="0"
      class="mx-auto"
    >
      <v-card-text>
        <v-row class="mx-0">
          <v-col cols="6">
            <v-btn
              class="raison-btn"
              @click="downloadSource"
            >
              <v-icon left>mdi-download</v-icon>
              {{ $t('sourceViewer.downloadSource') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12">
            <v-textarea
              class="rai-sourceviewer__textarea"
              :label="$t('sourceViewer.sourceCodes')"
              :value="source.source"
              solo
              readonly
              auto-grow
            />
          </v-col>
        </v-row>
        
      </v-card-text>
    </v-card>
  </div>

</template>

<script>
import PageContentToolbar from '@/components/layout/PageContentToolbar';
import playService from '@/services/play.js';

export default {
  name: 'SourceViewer',

  components: {
    PageContentToolbar,
  },

  mixins: [ ],

  data () {
    return {
      source: {},
      loadingSources: false,
      deleting: false,
    };
  },

  methods: {

    downloadSource () {
      let element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(this.source.source));
      element.setAttribute('download', this.source.id + '.pl');

      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },
    getSource() {
      const projectId = this.$route.params.id
      this.loadingSources = true
      console.log('getSource', projectId)
      return playService.viewSource(projectId)
        .then(res => {
          console.log(res.data)
          this.source = res.data
          this.source.source = atob(this.source.source)
          // this.source.source = Buffer.from(this.source.source, 'base64')
        }).catch(err => {
          this.$emit('raison-event', { type: 'error', messages: [err] });
        })
        .finally(() => {
          this.ready = true
          this.loadingSources = false
        });
    },
  },

  created() {
    this.loadingSources = true;
    this.getSource();
  },
}
</script>

<style>
.rai-sourceviewer__textarea {
  font-family: 'Courier New', Courier, monospace;
}
</style>